import Select from './Select';
import './Select.scss';

export default Select;
